import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { AccountMgtListFilterActionTypes, AccountMgtListFilterActions } from '../actions/account-mgt-list-filter.actions';


@Injectable()
export class AccountMgtListFilterEffects {
  private actions$ = inject(Actions);
  loadAccountMgtListFilters$= createEffect(() => this.actions$.pipe(
    ofType(AccountMgtListFilterActionTypes.LoadAccountMgtListFilters),
    /** An EMPTY observable only emits completion. Replace with your own observable API request */
    concatMap(() => EMPTY)
  ),
  { dispatch: false }
);


  constructor() {}

}
